<template>
  <el-popover placement="bottom-start" trigger="manual" v-model="isVisible">
    <div class="sc-tagil-pt-filters" v-loading="isLoading">
      <r-title>
        {{ $t("filter") }}
      </r-title>
      <ul class="sc-tagil-pt-filters__list">
        <li class="sc-tagil-pt-filters__item">
          <r-text colorType="subhead">
            {{ $t("type") }}
          </r-text>
          <el-select
            clearable
            v-model="transportType"
            :placeholder="$t('choose')"
            class="sc-tagil-pt-filters__select-item"
          >
            <el-option
              v-for="type in transportTypes"
              :key="type.id"
              :label="type.name === 'all' ? $t('all') : type.name"
              :value="type.id"
            >
            </el-option>
          </el-select>
        </li>
        <li class="sc-tagil-pt-filters__item">
          <r-text colorType="subhead">
            {{ $t("organization") }}
          </r-text>
          <el-select
            clearable
            v-model="organization"
            :placeholder="$t('choose')"
            class="sc-tagil-pt-filters__select-item"
          >
            <el-option
              v-for="org in organizationsNames"
              :key="org.id"
              :label="org.name === 'all' ? $t('all') : org.name"
              :value="org.id"
            >
            </el-option>
          </el-select>
        </li>
      </ul>
      <el-button
        class="sc-tagil-pt-filters__btn r-button"
        type="primary"
        @click="filterPtData"
      >
        {{ $t("apply") }}
      </el-button>
      <el-button
        class="sc-tagil-pt-filters__btn r-button plain small"
        type="primary"
        @click="clearFilter"
      >
        {{ $t("reset") }}
      </el-button>
      <i
        class="el-icon-close sc-tagil-pt-filters__btn-close"
        @click="$emit('closeFilter')"
      ></i>
    </div>
    <r-icon slot="reference" name="bus" :size="24" />
  </el-popover>
</template>

<script>
import { dataRequest } from "../../../configs";

export default {
  data() {
    return {
      baseUrl: "TagilPublicTransport?format=vehicles",
      transportType: null,
      organization: null,
      transportTypes: [],
      organizationsNames: []
    };
  },
  props: {
    layer_id: {
      type: String,
      required: true
    },
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isLoading() {
      return this.$store.state.situationCenter.filterConfig.isLoading;
    },
    request() {
      const filterLayer = this.$store.state.situationCenter.config.mapLayers.find(
        layer => layer.layer_id === this.layer_id
      );
      return filterLayer.request;
    }
  },
  methods: {
    toggleVisability() {
      this.isVisible = !this.isVisible;
    },
    getFilteredPtData() {
      if (
        Object.keys(this.$store.state.situationCenter.filterConfig.fields)
          .length
      ) {
        this.transportTypes = this.$store.state.situationCenter.filterConfig.fields.transportTypes;
        this.organizationsNames = this.$store.state.situationCenter.filterConfig.fields.organizationsNames;
      } else {
        const vehiclesData = this.$store.state.situationCenter.layersData.map[
          this.layer_id
        ];
        vehiclesData.forEach(pt => {
          if (
            !this.transportTypes.find(rt => rt.id === pt.vehicle_type.type_id)
          ) {
            this.transportTypes.push({
              id: pt.vehicle_type.type_id,
              name: pt.vehicle_type.name
            });
          }

          if (
            !this.organizationsNames.find(
              ro => ro.id === pt.organization.organization_id
            )
          ) {
            this.organizationsNames.push({
              id: pt.organization.organization_id,
              name: pt.organization.name
            });
          }
        });

        this.$store.commit("SET_SI_CENTER_FILTER_CONFIG", {
          field: "transportTypes",
          value: this.transportTypes
        });

        this.$store.commit("SET_SI_CENTER_FILTER_CONFIG", {
          field: "organizationsNames",
          value: this.organizationsNames
        });
      }
    },
    async filterPtData() {
      let url;

      this.$store.commit("SET_SI_CENTER_FILTER_CONFIG", {
        field: "isLoading",
        value: true
      });

      if (this.transportType || this.organization) {
        if (this.transportType && this.organization) {
          url = `${this.baseUrl}&vehicle_type_id=${
            this.transportType
          }&organization_id=${this.organization}`;
        } else {
          this.transportType
            ? (url = `${this.baseUrl}&vehicle_type_id=${this.transportType}`)
            : (url = `${this.baseUrl}&organization_id=${this.organization}`);
        }
        this.$store.commit("SET_SI_CENTER_FILTER_URL", {
          field: this.layer_id,
          value: url
        });
      } else {
        url = this.baseUrl;
        this.$store.commit("SET_SI_CENTER_FILTER_URL", {
          field: this.layer_id,
          value: null
        });
      }

      this.dataRequest(this, this.request, "map");
    },
    async clearFilter() {
      this.transportType = this.organization = null;
      this.$store.commit("REMOVE_SI_CENTER_FILTER_URL", this.layer_id);
      await this.filterPtData();
    },
    dataRequest
  },
  mounted() {
    this.getFilteredPtData();
  },
  beforeDestroy() {
    this.clearFilter();
  }
};
</script>

<style lang="scss">
.sc-tagil-pt-filters {
  position: relative;
  &__list {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }
  &__item {
    padding: 8px 0;
  }
  &__select-item {
    padding-top: 8px;
  }
  &__btn {
    align-items: flex-end;
    &-close {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 20px;
      color: var(--text_secondary);
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "type": "типу ТС",
    "organization": "организации",
    "filter": "Фильтровать по:",
    "reset": "Сбросить",
    "apply": "Применить",
    "choose": "Выберите из списка"
  },
  "en": {
    "type": "Transport type",
    "organization": "Organization name",
    "filter": "Filter by:",
    "reset": "Reset",
    "apply": "Apply",
    "choose": "Choose from the list"
  }
}
</i18n>
